import React from 'react';
import { useFormikContext } from 'formik';
import { label } from '@/shared/ui/core';
import IconCheck from '@/shared/assets/icon-check.svg';
import { FieldWrapper, RadioField, Label } from './ScoreInputs.styled';

export default React.forwardRef(({ name, label: labelProp, ...props }, ref) => {
  const { setFieldValue, values } = useFormikContext();

  return (
    <div>
      <span {...label(labelProp)}>{labelProp}</span>
      <FieldWrapper>
        {Array.from({ length: 10 }, (_, index) => index + 1).map((value) => {
          const id = `${name}-${value}`;

          return (
            <React.Fragment key={id}>
              <RadioField
                ref={ref}
                id={id}
                type="radio"
                name={name}
                value={value}
                onChange={(event) => setFieldValue(name, Number(event.target.value))}
                {...label(value)}
                {...props}
              />
              <Label htmlFor={id}>
                {values?.[name] === value ? <IconCheck /> : <span>{value}</span>}
              </Label>
            </React.Fragment>
          );
        })}
      </FieldWrapper>
    </div>
  );
});
